export const articlesUrl = "https://x.com/Harnoor29581982/articles";

// Add published articles here, newest first. Writing shows the first four.
// Use each article's direct URL, rather than the profile's Articles tab.
// {
//   title: "The exact published title",
//   summary: "A short description of the article.",
//   url: "https://x.com/Harnoor29581982/status/POST_ID",
//   publishedAt: "2026-10-20", // Optional, YYYY-MM-DD
//   tags: ["Topic"], // Optional
//   coverImage: "/articles/cover.jpg", // Optional, file in public/articles/
// }
export const articles = [];
